import './TodoMain.css'
export function TodoMain({ children }) {
	return <section className='TodoContainer'>{children}</section>
}
